/**
 * The ONE way a tenant reaches billing (TV1-2071).
 *
 * ── Why this is a constant and not a literal per surface ──────────────────────
 *
 * Two different screens now tell a tenant to contact billing, for two different
 * reasons, and both are dead ends if the address is wrong:
 *
 *   · the layout-level suspension banner (`contexts/useAuth/SuspensionBanner.tsx`),
 *     shown while the account is suspended for non-payment;
 *   · the cancellation notice on `/subscription` (`domains/subscription`), which is
 *     what stands in for self-service cancellation until `TV1-2237` gives the admin
 *     panel a real cancel affordance.
 *
 * A second literal is how those two silently diverge — the failure being a customer
 * mail bouncing off an address nobody reads, which nothing in CI can notice. One
 * constant makes the address a single edit and makes "the two surfaces agree" a
 * checkable claim (`domains/subscription/components/cancelViaBillingContact.test.ts`
 * asserts exactly that).
 *
 * It is a hardcoded address on purpose rather than configuration: it is Teselly's
 * own inbox, identical in every environment, and a mis-set env var would produce a
 * silently unreachable support route.
 */

/** Teselly's billing inbox. */
export const BILLING_CONTACT_EMAIL = 'billing@teselly.com';

/** The `href` for any "contact billing" affordance. */
export const BILLING_CONTACT_MAILTO = `mailto:${ BILLING_CONTACT_EMAIL }`;
